import React from 'react';
import { getBezierPath, getEdgeCenter } from 'react-flow-renderer';
import setting from "../../assets/images/settings.svg";
const ButtonEdge = ({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    style = {},
    markerEnd,
    data, // we can pass onButtonClick via data
}) => {
    // Create a curved path
    const edgePath = getBezierPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
    });

    //// Find the center of the edge
    //const [centerX, centerY] = getEdgeCenter({ sourceX, sourceY, targetX, targetY });

    const buttonX = targetX;
    const buttonY = targetY - 20;


    return (
        <>
            <path
                id={id}
                style={style}
                className="react-flow__edge-path"
                d={edgePath}
                markerEnd={markerEnd}
            />
            <foreignObject
                x={buttonX - 17}
                y={buttonY - 17}
                width={35}
                height={35}
            >
                <div className="edge-setting" alt="Data Profiles">
                    <img src={setting} alt="setting" />
                </div>

            </foreignObject>
        </>
    );
};

export default ButtonEdge;



//import React from 'react';
///*import { getBezierPath, getEdgeCenter } from 'react-flow-renderer';*/
//import { getSmoothStepPath } from 'react-flow-renderer';
//import setting from "../../assets/images/settings.svg";
//const ButtonEdge = ({
//    id,
//    sourceX,
//    sourceY,
//    targetX,
//    targetY,
//    sourcePosition,
//    targetPosition,
//    style = {},
//    markerEnd,
//    data, // we can pass onButtonClick via data
//}) => {
//    //// Create a curved path
//    //const edgePath = getBezierPath({
//    //	sourceX,
//    //	sourceY,
//    //	sourcePosition,
//    //	targetX,
//    //	targetY,
//    //	targetPosition,
//    //});

//    // Right-angled (orthogonal) path so every edge looks consistent
//    const edgePath = getSmoothStepPath({
//        sourceX,
//        sourceY,
//        sourcePosition,
//        targetX,
//        targetY,
//        targetPosition,
//        borderRadius: 0,
//    });

//    //// Find the center of the edge
//    //const [centerX, centerY] = getEdgeCenter({ sourceX, sourceY, targetX, targetY });

//    // Place the button right above the target node's connector (handle)
//    const buttonX = targetX;
//    const buttonY = targetY - 20;

//    return (
//        <>
//            <path
//                id={id}
//                style={{ ...style, stroke: "#4a4a4a", strokeWidth: 2 }}
//                className="react-flow__edge-path"
//                d={edgePath}
//                markerEnd={markerEnd}
//            />
//            <foreignObject
//                x={buttonX - 17}
//                y={buttonY - 17}
//                width={35}
//                height={35}
//            >
//                <div className="edge-setting" alt="Data Profiles">
//                    <img src={setting} alt="setting" />
//                </div>

//            </foreignObject>

//        </>
//    );
//};

//export default ButtonEdge;



